import React from "react";
import { withRouter } from "react-router-dom";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import HeaderContent from "../../components/layout/components/HeaderContent";
import OperationMap from "./components/OperationMap";

const Dashboard = () => {
  const breadcrumb = [{ link: "/dashboard", title: "Dashboard" }];

  return (
    <>
      <HeaderContent breadcrumb={breadcrumb} headerTitle="Dashboard" />

      <Card>
        <CardContent>
          <OperationMap />
        </CardContent>
      </Card>
    </>
  );
};

export default withRouter(Dashboard);
